import { VCS_AGENT_POOL_AGENTS_COLUMN_ID } from "../constants";
import VCSAgentPoolAgentsTableAgentIdCell from "./AgentIdCell";
import VCSAgentPoolAgentsTableDropdownCell from "./DropdownCell";
import VCSAgentPoolAgentsTableMetadataCell from "./MetadataCell";

export const VCS_AGENT_POOL_AGENTS_TABLE_CELLS = {
  [VCS_AGENT_POOL_AGENTS_COLUMN_ID.AGENT_ID]: VCSAgentPoolAgentsTableAgentIdCell,
  [VCS_AGENT_POOL_AGENTS_COLUMN_ID.METADATA]: VCSAgentPoolAgentsTableMetadataCell,
  [VCS_AGENT_POOL_AGENTS_COLUMN_ID.DROPDOWN]: VCSAgentPoolAgentsTableDropdownCell,
};
